import React  from 'react';
import DeliverableForm from './DeliverableForm';
 
export const BuildingMaintenance = () => {
    return <DeliverableForm category="BM" />
    };
